import { eraseCookie } from './cookies'

let redirecting = false

export const resetRedirectGuard = () => {
  redirecting = false
}

export const redirectToLogin = ({ location = window.location, redirect = (url) => location.replace(url) } = {}) => {
  if (redirecting) return

  eraseCookie(`${process.env.REACT_APP_WEBSITE_NAME}accessToken`)

  // Already on the login page - the pending redirectTo lives in the URL, so leave it (and any typed credentials) alone.
  if (location.pathname === '/login') return

  redirecting = true
  const currentPath = `${location.pathname}${location.search}${location.hash}`

  try {
    redirect(`/login?redirectTo=${window.btoa(currentPath)}`)
  } catch (error) {
    redirecting = false
    throw error
  }
}
